import React from "react";
import {
  Navigate,
  Outlet
} from "react-router-dom";

const AdminRoute = () => {

  const storedUser =
    localStorage.getItem(
      "currentUser"
    );

  const token =
    localStorage.getItem(
      "authToken"
    );

  if (!token || !storedUser) {
    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  let user = null;

  try {
    user =
      JSON.parse(storedUser);
  } catch (error) {
    console.error(
      "Invalid currentUser:",
      error
    );

    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  if (
    user?.role !==
    "ROLE_ADMIN"
  ) {
    return (
      <Navigate
        to="/suggestions"
        replace
      />
    );
  }

  return <Outlet />;
};

export default AdminRoute;